import { useCallback, useState } from 'react'
import { useGetUser, useUpdateUserDarkModeMutation } from '../api/user/user.ts'

export const useDarkMode = () => {
    const { data: user } = useGetUser()
    const { mutate: updateUserDarkMode } = useUpdateUserDarkModeMutation()

    const switchDarkMode = useCallback(() => {
        if (!user) {
            return
        }

        updateUserDarkMode(!user.appConfig?.darkMode)
    }, [user, updateUserDarkMode])

    return { darkModeEnabled: !!user?.appConfig?.darkMode, switchDarkMode }
}


export const usePublicDarkMode = () => {
    const [darkModeEnabled, setDarkModeEnabled] = useState(false)

    const switchDarkMode = useCallback(() => {
        setDarkModeEnabled((prev) => !prev)
    }, [])

    return {
        darkModeEnabled,
        switchDarkMode
    }
}
